export const DEV_BUILD_NUMBER = 'dev';

export const getBuildNumber = (): string =>
  process.env.NEXT_PUBLIC_BUILD_NUMBER ?? DEV_BUILD_NUMBER;
